import React, { useEffect } from 'react';

import { connect, shallowEqual, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { LayoutSplashScreen } from '../../../../_metronic/layout';
import { authSlice } from '../redux';
import { signOut } from '../redux/api';
import { AUTH_SIGN_IN_ROUTE } from '../routes';

function SignOut(props) {
  const { cognito } = useSelector(({ auth }) => auth, shallowEqual);

  useEffect(() => {
    void signOut()
      .then(props.signOut);
  }, [props.signOut]);

  if (cognito) {
    return <LayoutSplashScreen />;
  }

  return <Redirect to={AUTH_SIGN_IN_ROUTE} />;
}

export default connect(null, authSlice.actions)(SignOut);
